export default "__VITE_ASSET__bc4e66c4__"